import { useContext } from "react";
import { useTranslation } from "react-i18next";
import styled from "styled-components";
import Context from "../../../Context";

const Img = styled.img`
  height: 40px;
  width: 40px;
  /* cursor: pointer; */
  object-fit: contain;
`;

const Container = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: 20px;
  align-items: center;
  border-radius: 10px;
  height: 163px;
  width: 257px;
  color: var(--element);

  border: 1px solid var(--border);
  background-color: var(--surface);
  /* cursor: pointer; */

  @media (max-width: 900px) {
    height: 40vw;
    width: 40vw;
  }
`;

const Info = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 100%;
  gap: 5px;

  font-size: 12px;
  text-align: center;
  width: 90%;
  text-transform: uppercase;
  font-weight: 900;

  /* font-size: 18px; */
  font-weight: 700;
`;

const Title = styled.div`
  font-weight: 900;
  font-size: 10px;
  font-family: var(--headingFont);
`;

const Text = styled.div`
  font-weight: 600;
  font-size: 12px;
  font-family: var(--headingFont);
`;

const Icon = styled.div`
  display: flex;
  flex-direction: column;
  font-size: 30px;
`;

export default function HealthReportButton({
  icon,
  imageIcon,
  children,
  title,
}) {
  const { colorMode } = useContext(Context);

  const { t } = useTranslation();

  return (
    <Container>
      {/* {icon? <Icon> {icon} </Icon>:null} */}
      <Img
        style={{
          filter: colorMode == "DARK" ? "" : "brightness(0) saturate(0)",
        }}
        src={"/health-report-icons" + icon}
      />
      <Info>
        <Title>{title}</Title>
        <Text>{children}</Text>
      </Info>
    </Container>
  );
}
